<script>
import _ from 'lodash'
import InfiniteLoading from 'v3-infinite-loading'
import {
  ref,
  computed,
  onMounted,
  watch,
} from 'vue'
import {useRoute} from 'vue-router'
import {StandardListModel, ArticleListModel} from '@models'
import {useApplicationStore} from '@stores/application.store'
import ArticleItem from './components/article-item.vue'
import Articles from './components/articles.vue'
import ListMenu from './components/list-menu.vue'
import StandardListItem from './components/standard-list-item.vue'
import 'v3-infinite-loading/lib/style.css'

// standard list
const standardList = new StandardListModel()

standardList.category = 'premium'

// article list
const articleList = new ArticleListModel()

export default {
  name: 'StandardList',

  components: {
    InfiniteLoading,
    Articles,
    ArticleItem,
    StandardListItem,
    ListMenu,
  },

  provide: {
    standardList,
  },

  beforeRouteEnter (to, from, next) {
    next(() => {
      document.title = '精品自营车'
    })
  },

  setup () {
    // itemsOfStandard
    let itemsOfStandard = ref(null)
    // itemsOfArticle
    let itemsOfArtcile = ref([])
    //  standardListMenuDidShow
    let standardListMenuDidShow = ref(false)
    // indentifierOfStandardList
    let indentifierOfStandardList = ref(false)

    const route = useRoute()

    if (route.params.preview === 'preview') {
      standardList.enablePreview = true
    }

    const applicationStore = useApplicationStore()
    const DOMAIN = import.meta.env.VITE_DOMAIN

    onMounted(async () => {
      await loadArtciles()

      // wechat jssdk
      if (applicationStore.wechat) {
        wx && wx.ready(function () {
          wx.updateAppMessageShareData({
            title: '标准自营车｜爱车的诺诺',
            desc: '',
            link: `${DOMAIN}${route.fullPath}`,
            imgUrl: 'https://static.nuonuo.com.cn/zycmp/logo-zy.png',
          })

          wx.updateTimelineShareData({
            title: '标准自营车｜爱车的诺诺',
            link: `${DOMAIN}${route.fullPath}`,
            imgUrl: 'https://static.nuonuo.com.cn/zycmp/logo-zy.png',
          })
        })
      }
    })

    watch(standardListMenuDidShow, () => {
      const $body = document.querySelector('body')

      if (standardListMenuDidShow.value) {
        $body.style.overflow = 'hidden'
      }
      else {
        $body.style.overflow = 'unset'
      }
    })

    // loadStandards
    const loadStandards = async ($state) => {
      if (standardList.next) {
        await standardList.load()
        itemsOfStandard.value = standardList.items
        $state.loaded()
      }
      else {
        $state.complete()
      }
    }

    // itemsOfCombined
    const itemsOfCombined = computed(() => {
      if (!itemsOfStandard.value || !itemsOfStandard.value.length) {
        return []
      }

      const chunks = _
        .chain(itemsOfStandard.value)
        .chunk(8)
        .map((chunk, index) => {
          const article = _.nth(itemsOfArtcile.value, index)

          if (article && chunk.length === 8) {
            article.article = true

            return [
              ...chunk,
              article,
            ]
          }
          else {
            return chunk
          }
        })
        .flatten()
        .value()

      return chunks
    })

    // loadArticles
    const loadArtciles = async () => {
      await articleList.load()
      itemsOfArtcile.value = articleList.items
    }

    // starnardListMenuDidToggle
    const starnardListMenuDidToggle = (payload) => {
      standardListMenuDidShow.value = payload.show
    }

    // standardListMenuDidSubmit
    const standardListMenuDidSubmit = async () => {
      standardListMenuDidShow.value = false
      itemsOfStandard.value = []
      await standardList.composeParam()

      indentifierOfStandardList.value = !indentifierOfStandardList.value
    }

    return {
      // ref
      itemsOfStandard,
      itemsOfArtcile,
      standardListMenuDidShow,
      indentifierOfStandardList,
      // computed
      itemsOfCombined,
      // methods
      loadStandards,
      starnardListMenuDidToggle,
      standardListMenuDidSubmit,
    }
  },
}
</script>

<template>
  <div class="page-wrapper page-wrapper--standard-list">
    <div
      v-show="!standardListMenuDidShow"
      :class="['list-articles-wrapper']">
      <articles :items="itemsOfArtcile" />
    </div>

    <div :class="['list-menu-wrapper']">
      <list-menu
        :menu-name="'name'"
        @menu-toggled="starnardListMenuDidToggle"
        @menu-submitted="standardListMenuDidSubmit" />
    </div>

    <div
      :class="['list-combined-wrapper']">
      <template v-if="itemsOfCombined && itemsOfCombined.length">
        <div
          v-for="item in itemsOfCombined"
          :key="item.id">
          <template v-if="item.article">
            <article-item :item="item" />
          </template>
          <template v-else>
            <standard-list-item :item="item" />
          </template>
        </div>
      </template>

      <infinite-loading
        :identifier="indentifierOfStandardList"
        @infinite="loadStandards">
        <template #spinner>
          <div class="loading-indicator">加载中...</div>
        </template>

        <template #complete>
          <div class="no-more-indicator">不再显示更多</div>
        </template>
      </infinite-loading>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.page-wrapper.page-wrapper--standard-list {}

.list-articles-wrapper {
  z-index: 0;
  position: relative;
}

.list-menu-wrapper {
  position: sticky;
  top: var(--navigation-height);
  z-index: 100;
  background: var(--background);
}

.list-combined-wrapper {
  position: relative;
  z-index: 0;
}

// loading indicator
// no more indicator
.loading-indicator,
.no-more-indicator {
  height: 30px;
  line-height: 30px;
  text-align:center;
  padding: 30px;
  font-size: 1.1rem;
  color: #919191;
  font-weight: bold;
}

</style>

